import { Expose } from "class-transformer";
import { IsBoolean, IsOptional, IsString } from "class-validator";

export class BookingGetTemporaryContractorsResponse {
  @IsOptional()
  @IsString()
  @Expose()
  name: string | null = "";
  @IsOptional()
  @IsString()
  @Expose()
  surname: string | null = "";
  @IsOptional()
  @IsString()
  @Expose()
  country: string | null = "";
  @IsOptional()
  @IsString()
  @Expose()
  city: string | null = "";
  @IsOptional()
  @IsString()
  @Expose()
  postalCode: string | null = "";
  @IsOptional()
  @IsString()
  @Expose()
  streetAndNumber: string | null = "";
  @IsOptional()
  @IsString()
  @Expose()
  tin: string | null = "";
  @IsBoolean()
  @Expose()
  isIndividual = true;
  @IsOptional()
  @IsString()
  @Expose()
  importedContractorId: string | null = null;
  @IsOptional()
  @IsString()
  @Expose()
  nationalBusinessRegistryNumber: string | null = "";
  @IsBoolean()
  @Expose()
  exportOrderBetweenOffice = false;
}
